import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmployers, fetchEmployerDetail, clearSelectedEmployer } from '../../redux/slices/employersSlice';
import '../Users/UsersList.css'; // Reutilizar estilos

const EmployersList = () => {
  const dispatch = useDispatch();
  const { items, selectedEmployer, error } = useSelector((state) => state.employers);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('');

  useEffect(() => {
    dispatch(fetchEmployers({ q: search, filter }));
  }, [search, filter, dispatch]);

  const handleSelectEmployer = (employerId) => {
    dispatch(fetchEmployerDetail({ employerId }));
  };

  const handleCloseDetail = () => {
    dispatch(clearSelectedEmployer());
  };

  return (
    <div className="users-container">
      <div className="users-header">
        <h1>Empresas y empleadores</h1>
        <p>Gestiona en un único lugar las cuentas que publican ofertas.</p>
      </div>

      <div className="users-toolbar">
        <input
          type="text"
          placeholder="Buscar empresa, correo o ciudad"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="filter-select">
          <option value="">Todas las empresas</option>
          <option value="with_jobs">Con anuncios</option>
          <option value="active_jobs">Con anuncios activos</option>
        </select>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className={`users-layout ${selectedEmployer ? 'has-detail' : ''}`}>
        <div className="users-table-container">
          <table className="users-table">
            <thead>
              <tr>
                <th>Empresa / empleador</th>
                <th>Ciudad</th>
                <th>Anuncios</th>
                <th>Candidaturas</th>
                <th>Chats</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((employer) => (
                <tr key={employer.id}>
                  <td>
                    <div className="user-cell">
                      <div className="avatar">{employer.name[0]?.toUpperCase()}</div>
                      <div>
                        <strong>{employer.name}</strong>
                        <small>{employer.email}</small>
                      </div>
                    </div>
                  </td>
                  <td>{employer.city || '—'}</td>
                  <td>
                    <strong>{employer.active_jobs_count}</strong>
                    <small> activas / {employer.jobs_count} total</small>
                  </td>
                  <td>{employer.applications_count}</td>
                  <td>
                    <span className={`badge ${employer.open_chats_count > 0 ? 'active' : ''}`}>
                      {employer.open_chats_count} abiertos
                    </span>
                  </td>
                  <td className="action-cell">
                    <button
                      onClick={() => handleSelectEmployer(employer.id)}
                      className="btn btn-sm btn-link"
                    >
                      Ficha
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && <div className="empty-state">No hay empresas con esos filtros.</div>}
        </div>

        {selectedEmployer && (
          <aside className="detail-panel">
            <button onClick={handleCloseDetail} className="btn-close">×</button>
            <div className="detail-avatar">{selectedEmployer.name[0]?.toUpperCase()}</div>
            <span className="detail-type">EMPRESA / EMPLEADOR</span>
            <h2>{selectedEmployer.name}</h2>

            <dl className="detail-info">
              <dt>Correo</dt>
              <dd>{selectedEmployer.email}</dd>
              <dt>Teléfono</dt>
              <dd>{selectedEmployer.phone || 'No indicado'}</dd>
              <dt>Ciudad</dt>
              <dd>{selectedEmployer.city || 'No indicada'}</dd>
              <dt>Alta</dt>
              <dd>{new Date(selectedEmployer.created_at).toLocaleString('es-ES')}</dd>
            </dl>

            <p style={{ margin: '16px 0', fontSize: '14px', fontWeight: 600 }}>
              <strong>{selectedEmployer.active_jobs_count}</strong> anuncios activos ·
              <strong> {selectedEmployer.applications_count}</strong> candidaturas ·
              <strong> {selectedEmployer.open_chats_count}</strong> chats abiertos
            </p>

            <h3>Presentación</h3>
            <p className="bio">{selectedEmployer.bio || 'Sin descripción.'}</p>
          </aside>
        )}
      </div>
    </div>
  );
};

export default EmployersList;
